var React = require('react');

function Keepstar (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:none;stroke:#000;stroke-linecap:square;stroke-linejoin:bevel;stroke-width:2px;}")),React.createElement("title",{"key":1},"Keepstar"),React.createElement("path",{"id":"path1618","className":"cls-1","d":"M114,22.33H80.67V64H47.33V22.33H14v83.34H114Z","key":2})]);
}

Keepstar.defaultProps = {"id":"svg8","viewBox":"0 0 128 128"};

module.exports = Keepstar;

Keepstar.default = Keepstar;
